export default "__VITE_ASSET__yOyHvkA9__"